import React from "react";

const SearchIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 15 15"
    >
      <path
        id="search"
        d="M13.614,15a1.376,1.376,0,0,1-.979-.406l-1.287-1.287A7.278,7.278,0,0,1,2.129,2.131,7.279,7.279,0,0,1,14.555,7.278a7.222,7.222,0,0,1-1.248,4.071l1.287,1.287A1.385,1.385,0,0,1,13.614,15ZM7.276,2.77A4.506,4.506,0,1,0,10.464,4.09,4.485,4.485,0,0,0,7.276,2.77Z"
        transform="translate(0 0)"
        fill="#fff"
      />
    </svg>
  );
};

export default SearchIcon;
